export default "__VITE_ASSET__DwObI3cB__"